// features/shared/hooks/use-breakpoints.ts
'use client';

import { useMediaQuery } from './use-media-query';
import breakpoints from '@/shared/utils/breakpoints';

export const useIsSm = () => useMediaQuery(`(min-width: ${breakpoints.sm})`);
export const useIsMd = () => useMediaQuery(`(min-width: ${breakpoints.md})`);
export const useIsLg = () => useMediaQuery(`(min-width: ${breakpoints.lg})`);
export const useIsXl = () => useMediaQuery(`(min-width: ${breakpoints.xl})`);
export const useIs2xl = () => useMediaQuery(`(min-width: ${breakpoints['2xl']})`);
